import Tree from '../Tree/Tree';
import FormSection from '../FormSection/FormSection';
import { buildTeamHierarchy } from '../../../utils/functions';

import './ActiveTeamsTree.scss';

interface IActiveTeamsTreeProps {
  teams?: ITeam[];
  activeTeams?: string[];
  isLocked?: boolean;
  subHeader?: string;
  noDefault?: boolean;
  isSearchable?: boolean;
  showTooltip?: boolean;
  error?: string;
  onSelectedChange: (selectedIds: string[]) => void;
}

const ActiveTeamsTree = ({
  teams,
  activeTeams,
  isLocked = false,
  subHeader = 'Teams',
  noDefault,
  isSearchable = false,
  showTooltip = false,
  error,
  onSelectedChange,
}: IActiveTeamsTreeProps) => {
  const treeData = buildTeamHierarchy({ teams, sorted: true });

  return (
    <FormSection
      className="ActiveTeamsTree"
      subheader={subHeader}
      info="Select which teams appear in your reports."
      tooltip={
        showTooltip
          ? {
              id: 'tooltip-teams',
              icon: 'help',
              placement: 'right',
              text: 'Teams for which you have reporting access',
            }
          : undefined
      }
    >
      <Tree
        binarySelect
        startExpanded
        data={treeData}
        isLocked={isLocked}
        hideExpandCollapse={!noDefault}
        initialSelections={activeTeams}
        searchable={isSearchable}
        hasClearAll={noDefault}
        error={error}
        onSelectedChange={onSelectedChange}
      ></Tree>
    </FormSection>
  );
};

export default ActiveTeamsTree;
